import { persistSettings } from '@/lib/persistSettings';
import type { ProductListItem } from '@/productBrowser/productBrowserTypes';
import type { Brand } from '@whiz-cart/node-shared/models/brand/brand';
import { createStore } from 'cross-state';

type recentStoreItems = {
    [storeGuid: string]: { items: ProductListItem[] };
};

export type CartSorting = { by: 'active' | 'lastSeen' | 'battery'; order: 'asc' | 'desc' };

export const appState = createStore({
    recentProducts: {} as recentStoreItems,
    navigationGroupsCollapse: {} as { [groupName: string]: boolean },
    navigationItemsOpen: {} as { [path: string]: boolean },
    pinnedNavigationItems: [] as string[],
    cartSorting: undefined as CartSorting | undefined,
    overrideBrand: undefined as Brand | undefined,
});

export const appStateReady = persistSettings(appState, 'appState', [
    'recentProducts',
    'navigationGroupsCollapse',
    'navigationItemsOpen',
    'pinnedNavigationItems',
    'cartSorting',
]);

if (typeof window !== 'undefined') {
    Object.assign(window, { appState });
}
